export default "__VITE_ASSET__D9g_KP0t__"